import { useEffect, useRef } from 'react';

export function GravityCursor() {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const el = ref.current;
    if (!el) return;

    const target = { x: window.innerWidth * 0.5, y: window.innerHeight * 0.5 };
    const current = { ...target };
    let raf = 0;

    const onMove = (event: PointerEvent) => {
      target.x = event.clientX;
      target.y = event.clientY;
      el.classList.add('is-visible');
      el.classList.toggle(
        'is-action',
        event.target instanceof Element && !!event.target.closest('a, button, [role="button"]'),
      );
    };
    const onDown = () => el.classList.add('is-pressed');
    const onUp = () => el.classList.remove('is-pressed');
    const tick = () => {
      const velocity = Math.abs(window.__planetScrollVelocity ?? 0);
      const follow = 0.16 + velocity * 0.08;
      current.x += (target.x - current.x) * follow;
      current.y += (target.y - current.y) * follow;
      el.style.transform = `translate3d(${current.x}px, ${current.y}px, 0) translate(-50%, -50%) scaleX(${1 + velocity * 0.75})`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('pointerup', onUp, { passive: true });
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointerup', onUp);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div ref={ref} className="gravity-cursor" aria-hidden="true">
      <span className="gravity-cursor__cross gravity-cursor__cross--x" />
      <span className="gravity-cursor__cross gravity-cursor__cross--y" />
    </div>
  );
}

export default GravityCursor;
